export default 'gas-list';
